import { Routes } from '@angular/router';
import { ADMIN_GROUP, AuthGuard, TECH_ADMIN_GROUP } from './core/guards/auth.guard';
import { legalRoutes } from './legal/legal.routes';
import { loginRoutes } from './main/pages/login/login.routes';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./main/main.routes').then(m => m.mainRoutes)
  },
  /** Eager route tree so session-expiry redirects never depend on a lazy chunk fetch. */
  {
    path: 'login',
    children: loginRoutes
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.routes').then(m => m.onboardingRoutes),
    title: 'EVready Energy - Onboarding'
  },
  ...legalRoutes,
  {
    path: 'simplify',
    loadChildren: () => import('./simplify/simplify.routes').then(m => m.simplifyRoutes),
    title: 'EVready - Simplify',
    canActivate: [AuthGuard],
    data: { roles: [ADMIN_GROUP, TECH_ADMIN_GROUP] }
  },
  {
    path: 'setup',
    loadChildren: () => import('./setup/setup.routes').then(m => m.setupRoutes),
    title: 'EVready - Setup',
    canActivate: [AuthGuard],
    data: { roles: [ADMIN_GROUP] }
  },
  {
    path: 'coach',
    loadChildren: () => import('./coach/coach.routes').then(m => m.coachRoutes),
    title: 'EVready - Coach',
    canActivate: [AuthGuard]
  },
  {
    path: 'guardian',
    loadChildren: () => import('./guardian/guardian.routes').then(m => m.guardianRoutes),
    title: 'EVready - Guardian',
    canActivate: [AuthGuard]
  },
  {
    path: 'health',
    loadChildren: () => import('./health/health.routes').then(m => m.healthRoutes),
    title: 'EVready - Health',
    canActivate: [AuthGuard]
  },
  {
    path: 'review',
    loadChildren: () => import('./review/review.routes').then(m => m.reviewRoutes),
    title: 'EVready - Review',
    canActivate: [AuthGuard],
    data: { roles: [ADMIN_GROUP] }
  },
  {
    path: 'tech-admin',
    loadChildren: () => import('./tech-admin/tech-admin.routes').then(m => m.techAdminRoutes),
    title: 'EVready - TechAdmin',
    canActivate: [AuthGuard],
    data: { roles: [TECH_ADMIN_GROUP] }
  },
  {
    path: '**',
    redirectTo: ''
  }
];
